import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import { appsConfig } from "./config";
import {
  getParams,
  AppLauncher,
  showInfoDialog,
  Device,
  Rem,
} from "@fe_utils/fe_sdk_base";
import _ from "lodash";

import useIsPhone from "../../hooks/useIsPhone";
import { showAppModal } from "./components/showModal";

const name = getParams("name");
const channel = getParams("channel") || "android";
const appConfig = _.find(appsConfig, { name });

const AppHomepage = () => {
  const isPhone = useIsPhone();
  const appLauncher = useRef(null);
  if (isPhone) {
    Rem.init(37.5, 1, false);
  } else {
    Rem.resetRem(50);
  }

  useEffect(() => {
    appLauncher.current = new AppLauncher(appConfig.schemeName);
  }, []);

  const downloadApp = () => {
    if (isPhone) {
      const callBackAfter5Seconds = (result) => {
        if (!result) {
          showInfoDialog({
            title: "跳转失败",
            message: `请手动前往${
              Device.isIOS ? "App Store" : "应用商店"
            }搜索下载`,
          });
        }
      };
      appLauncher.current.openAppWithMarketLink(callBackAfter5Seconds);
    } else {
      showAppModal({
        appName: appConfig.appName,
        appIcon: appConfig.appIcon,
      });
    }
  };
  return (
    <Wrapper>
      <Header>
        <img src={require("../../asset/images/website_name.png")} alt="" />
      </Header>
      <Content>
        <AppCard>
          <img
            className="bg"
            src={isPhone ? appConfig.phoneCardBgImg : appConfig.pcCardBgImg}
            alt=""
          />
          <img className="icon" src={appConfig.appIcon} alt="" />
          <div className="appName">{appConfig.appName}</div>
          <div className="appIntrWrapper">
            {_.map(appConfig.appIntr, (item, index) => (
              <div className="appIntr" key={index}>
                {item}&nbsp;&nbsp;
              </div>
            ))}
          </div>
          <div className="downloadBtn" onClick={downloadApp}>
            <img src={require("./image/download_icon.png")} alt="" />
            下载应用
          </div>
          <div className="agreement">
            <span
              onClick={() =>
                window.open(
                  `https://base.quthing.com/base/agreement/user.html?appPackage=${name}_${channel}&appChannel=${channel}`,
                  "_blank"
                )
              }
            >
              用户协议
            </span>
            、
            <span
              onClick={() =>
                window.open(
                  `https://base.quthing.com/base/agreement/privacy.html?appPackage=${name}_${channel}&appChannel=${channel}`,
                  "_blank"
                )
              }
            >
              隐私政策
            </span>
          </div>
        </AppCard>
      </Content>
      <div style={{ flex: 1 }}></div>
      <Footer>
        <Copyright>
          <img src={require("../../asset/images/copyright_icon.png")} alt="" />
          2021 北京夕航科技有限公司版权所有 |
          <span
            onClick={() => window.open("https://beian.miit.gov.cn/", "_blank")}
          >
            京ICP备18026356号-1
          </span>
          |
        </Copyright>
        <PublicSecurity>
          <img
            src={require("../../asset/images/public_security_record_no.png")}
            alt=""
          />
          <span
            onClick={() =>
              window.open(
                "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802030270",
                "_blank"
              )
            }
          >
            京公网安备 11010802030270号
          </span>
        </PublicSecurity>
      </Footer>
    </Wrapper>
  );
};

export default AppHomepage;

const Wrapper = styled.div`
  width: 100%;
  height: max-content;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Header = styled.div`
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  > img {
    margin-left: 16px;
    height: 29px;
  }
  ${breakpoint("desktop")`
      height: 68px;
      border: 1px solid #F2F2F2;
      > img {
        margin-left: 283px;
        height: 38px;
      }
    `}
`;
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 85px;
  margin-bottom: 74px;
  width: 100%;
  aspect-ratio: 375/467;
  background-image: url(${require("./image/phone_content_bg.png")});
  background-size: contain;
  background-repeat: no-repeat;
  ${breakpoint("desktop")`
    margin-top: 83px;
    margin-bottom: 0;
    width: 932px;
    aspect-ratio: 1184/694;
    background-image: url(${require("./image/pc_content_bg.png")});
  `}
`;
const AppCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 260px;
  height: 437px;
  background: #ffffff;
  box-shadow: rgba(101, 43, 0, 0.08) 0px 2px 12px 0px;
  border-radius: 14px;
  > .bg {
    width: 100%;
    border-radius: 14px;
  }
  > .icon {
    width: 64px;
    margin-top: -49px;
  }
  > .appName {
    margin-top: 4px;
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 14px;
    color: #35374e;
    line-height: 20px;
    text-align: center;
    font-style: normal;
  }
  > .appIntrWrapper {
    > div {
      font-weight: 400;
      font-size: 14px;
      color: #4b4f5a;
      line-height: 20px;
      text-align: center;
      font-style: normal;
    }
  }
  > .downloadBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 26px;
    width: 172px;
    height: 46px;
    background: #ffab18;
    border-radius: 28px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    > img {
      margin-right: 9px;
      width: 21px;
    }
  }
  > .agreement {
    margin-top: 8px;
    font-weight: 400;
    font-size: 10px;
    color: #ffab18;
    line-height: 14px;
    text-align: center;
    font-style: normal;
  }
  ${breakpoint("desktop")`
    width: 775px;
    height: 499px;
    border-radius: 22px;
    > .bg {
      width: 100%;
      border-radius: 22px;
    }
    > .icon {
      width: 101px;
      margin-top: -74px;
    }
    > .appName {
      margin-top: 6px;
      margin-bottom: 6px;
      font-weight: bold;
      font-size: 22px;
      color: #35374e;
      line-height: 32px;
      text-align: center;
      font-style: normal;
    }
    > .appIntrWrapper {
      display: flex;
      > div{
        font-weight: 400;
        font-size: 22px;
        color: #4b4f5a;
        line-height: 32px;
        text-align: center;
        font-style: normal;
      }
    }
    > .downloadBtn {
      margin-top: 24px;
      width: 283px;
      height: 72px;
      background: #ffab18;
      border-radius: 48px;
      font-weight: 500;
      font-size: 28px;
      color: #ffffff;
      line-height: 39px;
      text-align: left;
      font-style: normal;
      > img {
        margin-right: 9px;
        width: 38px;
      }
    }
    > .agreement {
      margin-top: 13px;
      font-weight: 400;
      font-size: 16px;
      color: #ffab18;
      line-height: 22px;
      text-align: center;
      font-style: normal;
    }
  `}
`;
const Footer = styled.div`
  width: 100%;
  background: rgba(240, 241, 243, 0.5);
  font-weight: 400;
  font-size: 12px;
  color: #9c9ea5;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${breakpoint("desktop")`
    flex-direction: row;
    justify-content: center;
    font-size: 13px;
    padding: 19px 0;
  `}
`;
const Copyright = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  height: 17px;
  > img {
    margin-right: 4px;
    width: 16px;
  }
  > span {
    cursor: pointer;
    &:hover {
      color: #123400;
    }
  }
  ${breakpoint("desktop")`
    margin-top: 0;
    margin-right: 95px;
  `}
`;

const PublicSecurity = styled.div`
  margin-top: 12px;
  margin-bottom: 36px;
  display: flex;
  align-items: center;
  height: 17px;
  > img {
    margin-right: 4px;
    width: 16px;
  }
  > span {
    cursor: pointer;
    &:hover {
      color: #123400;
    }
  }
  ${breakpoint("desktop")`
    margin-top: 0;
    margin-bottom: 0;
  `}
`;
